import { createSelector } from 'reselect';

export const getVisualizationsLoaded = (state) => state.visualizations.siteLoaded;

const getMappedVisualizations = (state) => state.visualizations.visualizations;

export const getVisualizations = createSelector(getMappedVisualizations, (visualizations) =>
  Object.values(visualizations)
);

export const getVisualizationSubscriptions = (state) => state.visualizations.subscriptions;

export const getVisualizationValues = (state) => state.visualizations.values;

export const getVisualization = createSelector(
  getMappedVisualizations,
  (_, id) => id,
  (visualizations, id) => visualizations[id]
);

export const getVisualizationsImportedAt = (state) => state.visualizations.visualizationsImportedAt;

export const getImportErrors = (state) => state.visualizations.importErrors;

export const getVisualizationTemplateTypes = (state) => state.visualizations.templateTypes;
